import React from 'react'
import { View, Text, StyleSheet, StyleProp, TextStyle } from 'react-native'
import { useTranslation } from 'react-i18next'
import { PaymentMethodDetails } from './PaymentMethodDetails'
import AddPaymentMethodButtons from './AddPaymentMethodButtons'
import { IPaymentMethodData } from '../flows/PayAsGuestFlow/types'

interface PaymentMethodProps {
  paymentMethod?: IPaymentMethodData | null
  onAddCardPress: () => void
  onRemovePaymentMethod: () => void
  phoneNumber: string
  sectionTitleStyle?: StyleProp<TextStyle>
}

export const PaymentMethod: React.FC<PaymentMethodProps> = ({
  paymentMethod,
  onAddCardPress,
  onRemovePaymentMethod,
  sectionTitleStyle,
  phoneNumber,
}) => {
  const { t } = useTranslation('global')

  return (
    <View>
      <Text style={[styles.sectionTitle, sectionTitleStyle]}>
        {t('integrations.pay-as-guest.payment-method-section.payment-method')}
      </Text>

      {paymentMethod ? (
        <PaymentMethodDetails
          paymentMethod={paymentMethod}
          onRemove={onRemovePaymentMethod}
        />
      ) : (
        <AddPaymentMethodButtons
          onAddCardPress={onAddCardPress}
          phoneNumber={phoneNumber}
        />
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  sectionTitle: {
    fontSize: 20,
    lineHeight: 28,
    fontWeight: '700',
    fontFamily: 'Inter',
    color: '#001929',
    marginBottom: 18,
  },
  addPaymentButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    height: 48,
    borderWidth: 2,
    borderColor: '#00A0F3',
    borderRadius: 8,
    marginBottom: 12,
    backgroundColor: '#FFFFFF',
  },
  addPaymentButtonText: {
    color: '#00A0F3',
    fontWeight: '600',
    fontSize: 14,
  },
  paymentMethodContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16,
    backgroundColor: '#F8F9F9',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#D3D3D3',
    marginBottom: 12,
  },
  paymentMethodDetailsContainer: {
    flex: 1,
    marginRight: 8,
  },
  paymentMethodType: {
    fontSize: 14,
    fontWeight: '600',
    marginBottom: 4,
    color: '#001929',
  },
  paymentMethodDetails: {
    fontSize: 14,
    color: '#394D5A',
    marginBottom: 4,
  },
  paymentMethodOwner: {
    fontSize: 14,
    color: '#001929',
  },
})
